import { render, staticRenderFns } from "./NavTabsTable.vue?vue&type=template&id=b3fc6342"
import script from "./NavTabsTable.vue?vue&type=script&lang=js"
export * from "./NavTabsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports